import React from "react";
import { Checkbox, Row, Col } from "antd";
import styles from "./CheckboxContent.scss";

const CheckboxContent = ({ options, value, onChange }) => (
  <Checkbox.Group
    onChange={onChange}
    className={styles.checkboxGroup}
    value={value}
  >
    <Row type="flex" align="middle">
      {options.map((option, index) => (
        <Col
          key={index /* eslint-disable-line */}
          xs={24}
          lg={12}
          className={styles.checkboxWrapper}
        >
          <Checkbox value={option.value} className={styles.checkbox}>
            {option.title}
          </Checkbox>
        </Col>
      ))}
    </Row>
  </Checkbox.Group>
);

CheckboxContent.defaultProps = {
  onChange: () => null,
  options: [],
  value: []
};

export default CheckboxContent;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiSelector/CheckboxContent/index.tsx